import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let json = JSON.parse(this.element.dataset.json);
    let stringifyJson = JSON.stringify(json, undefined, 2);
    this.element.innerHTML = stringifyJson;
  }
};